import { render, staticRenderFns } from "./sliderTagSelector.vue?vue&type=template&id=6edd944a"
import script from "./sliderTagSelector.vue?vue&type=script&lang=js"
export * from "./sliderTagSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports